import React from 'react';
import { ROUTES } from './constants';
import { Route } from 'circe/routing/provider';
import { Loadable } from 'circe/loadable/provider';
import { AUTHORITIES } from 'domain/fuse/auth/constants';
import RequireAuth from 'circe/authorization/components/AuthorizationRoute';

import MineRoutes from 'domain/shipment/mine/routes';
import ViewRoutes from 'domain/shipment/view/routes';
import BookRoutes from 'domain/shipment/book/routes';
import PdfRoutes from 'domain/shipment/pdf/routes';
import OrderRoutes from 'domain/shipment/order/routes';
import OrdersRoutes from 'domain/shipment/orders/routes';
import HistoryRoutes from './history/routes';
import AddressUpdateRoutes from 'domain/shipment/address/routes';
import BulkRoutes from 'domain/shipment/bulk/routes';
import UpdateStatusRoutes from 'domain/shipment/updateStatus/routes';
import AssignRoutes from 'domain/shipment/assign/routes';
import ReportRoutes from 'domain/shipment/report/routes';
import NewOrderRoutes from 'domain/shipment/newOrder/routes';
import WaybillsRoutes from 'domain/shipment/waybills/routes';
import ForecastDatRoutes from 'domain/shipmentsManagement/forecastDATOrders/routes';
import BatchOrdersRoutes from 'domain/shipment/batchOrders/routes';
import { loadComponent } from 'domain/layout/utils';

/* istanbul ignore next */
const shipmentsContainer = loadComponent(() => import('domain/shipment/container'));

export const authorizedShipmentsContainer = RequireAuth(
  shipmentsContainer,
  [AUTHORITIES.OPERATOR, AUTHORITIES.ACCOUNT_ADMIN, AUTHORITIES.DISPATCHER],
  '/address-book/query',
);

const Routes = () => [
  <Route exact path={ROUTES.ROOT} key={ROUTES.ROOT} component={authorizedShipmentsContainer} />,
  <MineRoutes key={'MineRoutes'} />,
  <ViewRoutes key={'ViewRoutes'} />,
  <OrderRoutes key={'OrderRoutes'} />,
  <BookRoutes key={'BookRoutes'} />,
  <PdfRoutes key={'PdfRoutes'} />,
  <OrdersRoutes key={'OrdersRoutes'} />,
  <HistoryRoutes key="HistoryRoutes" />,
  <AddressUpdateRoutes key="AddressUpdateRoutes" />,
  <UpdateStatusRoutes key="UpdateStatusRoutes" />,
  <AssignRoutes key="AssignRoutes" />,
  <ReportRoutes key="ReportRoutes" />,
  <NewOrderRoutes key="NewOrderRoute" />,
  <WaybillsRoutes key="WaybillsRoutes" />,
  <ForecastDatRoutes key="ForecastDatRoutes" />,
  <BatchOrdersRoutes key="BatchOrdersRoutes" />,
];

export default Routes;
